// Fonction spéciale sans génération de code JS côté client (traitement côté worker, mode "file")
export default {
  functionKey: "GRANDE.VALEUR COLONNE",
  title: "GRANDE.VALEUR COLONNE",
  group: "Calcul colonne",
  origin: [],
  multiOrigin: true,
  arguments: [],
  maxArguments: 2,
  showTypeOptions: { origin: false, target: false, arguments: false },
  requiredArguments: [
    { argumentKey: "N", name: "Rang" },
    { argumentKey: "Label", name: "Libellé du résultat" }
  ],
  expectedArguments: [
    { name: "Rang", argumentKey: "N", single: true, initialValue: "1" },
    { name: "Libellé du résultat", argumentKey: "Label", single: true, initialValue: "Grande.valeur" }
  ],
  description: "Retourne la Nième plus grande valeur d'une ou plusieurs colonnes (1 = maximum, lignes filtrées par les conditions).",
  details: "Retourne la Nième plus grande valeur numérique parmi une ou plusieurs colonnes d'origine (sur les lignes respectant les conditions du bloc, 1 = maximum — plusieurs colonnes sont combinées en un seul ensemble). Ajoute une nouvelle ligne de résultat (colonnes __fonction__ / __resultat__) sans modifier les lignes existantes.",
  isStarred: false,

  generate: null
}
